// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll(".gift-coffee-grind-type-option");
//   const hiddenInput = document.getElementById("gift-coffee-grind-type-input");
//   buttons.forEach((button) => {
//     button.addEventListener("click", () => {
//       buttons.forEach((b) => b.classList.remove("selected"));
//       button.classList.add("selected");
//       hiddenInput.value = button.dataset.grind;
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".gift-coffee-grind-type-option");
  
  const textarea = document.querySelector('textarea[name="properties[Gift Message]"]');
  const recipientName = document.querySelector('input[name="properties[Recipient Name]"]');
  const recipientEmail = document.querySelector('input[name="properties[Recipient Email]"]');

  recipientName?.addEventListener("input", () => {
    if (recipientName.value.length >50) {
      recipientName.value = recipientName.value.slice(0, 50); // cut off extra characters
    }
  });

  recipientEmail?.addEventListener("input", () => {
    if (recipientEmail.value.length >50) {
      recipientEmail.value = recipientEmail.value.slice(0, 60); // cut off extra characters
    }
  });
  
  
  textarea?.addEventListener("input", () => {
    const counter = document.getElementById("remaining_chars");
    // if (textarea.value.length > 250) {
    //   textarea.value = textarea.value.slice(0, 250); // cut off extra characters
    // }
    const maxLength = parseInt(textarea.getAttribute('maxlength'), 10) || 255;

    const remaining = Math.max(0, maxLength - textarea.value.length);
    counter.textContent = remaining;
  });

  buttons.forEach(button => {
    button.addEventListener("click", () => {
        const elem = document.getElementById("gift-coffee-grind-type-input");
      // remove active class from all buttons
      buttons.forEach(btn => btn.classList.remove("active"));
      
      // add active class to clicked button
      button.classList.add("active");

      // handle selected value
      const selectedValue = button.dataset.grind;
      console.log("Selected option:", selectedValue);
      elem.value = selectedValue;

      // 👉 You can add custom logic here
    });
  });
});